<template>
  <section>
    <title>Dashboard | Auto Punishments</title>
    <div class="page-loader" v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
    <div class="state-bar" v-if="loaded">
      <a href="/dashboard">Go To The Server Selection Menu</a>
    </div>
    <form class="form margin-border" v-if="loaded">
      <div class="form-field">
        <h2>Create Punishment:</h2>
        <p class="form-field-title">{{ typeOpt.value === 'null' ? '> ' : '' }}Punishment <span class="text-red">*</span></p>
        <p class="form-field-title-description">Pick the type of punishment to use:</p>
        <v-select :options="typeOptions" @input="formUpdate()" v-model="typeOpt"></v-select>
      </div>

      <div class="form-field" v-if="['tempmute', 'tempban'].includes(typeOpt.value)">
        <p class="form-field-title">{{ durationOpt.value === 'null' || isNaN(parseInt(durationInt)) ? '> ' : '' }}Duration <span class="text-red">*</span></p>
        <p class="form-field-title-description">The duration for the {{ typeOpt.label.toLowerCase() }}, type an amount then pick a unit of time:</p>
        <div class="input-wrapper">
          <input type="number" name="duration-nr" @input="formUpdate()" v-model="durationInt" class="form-field-text-input duration-number-input" placeholder="Amount, ex. 5">
          <v-select class="duration-input-type" :options="durationOptions" @input="formUpdate()" v-model="durationOpt"></v-select>
        </div>
        <p class="form-field-title-description text-info" style="margin-top: 0.5em" v-if="durationOpt.value !== 'null' && !isNaN(parseInt(durationInt))">The user will be {{ punishmentValueToPastAction[typeOpt.value] }} for {{ parseInt(durationInt) }} {{ `${unitValueToTime[durationOpt.value]}${parseInt(durationInt) === 1 ? '' : 's'}` }}.</p>
      </div>

      <div class="form-field" v-if="(['tempmute', 'tempban'].includes(typeOpt.value) && durationOpt.value !== 'null' && !isNaN(parseInt(durationInt))) || ['kick', 'permaban'].includes(typeOpt.value)">
        <p class="form-field-title">{{ isNaN(parseInt(strikesInt)) ? '> ' : '' }}Strikes Required <span class="text-red">*</span></p>
        <p class="form-field-title-description">Upon how many strikes user will receive this punishment.</p>
        <input type="number" name="strike-amount" @inpit="formUpdate()" v-model="strikesInt" v-bind:class="{ 'form-field-text-input': true, 'field-input-error': displayPunishments.find(punishment => punishment.amount === strikesInt) }" placeholder="Amount of strikes.">
        <p class="form-field-title-description input-error" v-if="displayPunishments.find(punishment => punishment.amount === strikesInt)">There's already a punishment with this amount of strikes!</p>
      </div>

      <div class="button-flex-container" style="margin: 1.5em 0;">
        <a v-bind:class="{ 'button-secondary': true, 'button-inactive': !canAddPunishment }" @click="savePunishment()"><i class="fas fa-plus"></i> Create Punishment</a>
        <a v-bind:class="{ 'button-danger': true, 'button-inactive': !canDiscardPunishment }" @click="discardPunishment()"><i class="fas fa-trash"></i> Ignore: Punishment</a>
      </div>

      <div class="punishment-showcase" v-if="canAddPunishment">
        ModCord will {{ getPunishmentActionText() }} upon reaching a minimum of {{ parseInt(strikesInt) }} strikes.
      </div>
    </form>

    <div class="divisor" v-if="loaded"></div>
    <h2 class="empty-message" v-if="loaded && !displayPunishments.length">No punishments set.</h2>
    <h3 class="head-title-under-line-child little-margin" v-if="loaded && displayPunishments.length">Current Punishments</h3>
    <ul class="option-list" v-if="loaded && displayPunishments.length">
      <li class="option-list-item" v-for="punishment in index(displayPunishments)" v-bind:key="punishment.index">
        <a href="javascript:void(0)" @click="remove(punishment.index)" class="btn-icon">
          <i class="fas fa-trash"></i>
        </a>
        <span>
          Upon reaching {{ punishment.amount }} strike{{ punishment.amount == 1 ? "" : "s" }}, ModCord will {{ punishment.action }} this user{{ punishment.duration && !punishment.duration.startsWith("null") ? ` for ${fetchDuration(punishment.duration)}` : "" }}.
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "Punishments",
  watch: {
    confirm (value) {
      this.$emit("setPromptVisibility", value);
    },
    saving (value) {
      this.$emit("setPromptLoading", value);
    }
  },
  data () {
    return {
      loaded: false,
      settings: {},
      cache: {},
      changes: {},
      saving: false,
      confirm: false,
      displayPunishments: [],
      typeOptions: [
        {
          "label": "Kick Out",
          "value": "kick"
        },
        {
          "label": "Temporary Mute",
          "value": "tempmute"
        },
        {
          "label": "Temporary Ban",
          "value": "tempban"
        },
        {
          "label": "Permanent Ban",
          "value": "permaban"
        }
      ],
      saveAble: false,
      durationOptions: [
        {
          "label": "Seconds",
          "value": "s"
        },
        {
          "label": "Minutes",
          "value": "m"
        },
        {
          "label": "Hours",
          "value": "h"
        },
        {
          "label": "Days",
          "value": "d"
        }
      ],
      typeOpt: {
        label: "-",
        value: "null"
      },
      durationOpt: {
        label: "-",
        value: "null"
      },
      strikesInt: null,
      durationInt: null,
      punishmentValueToPastAction: {
        tempmute: "muted",
        tempban: "banned"
      },
      unitValueToTime: {
        s: "second",
        m: "minute",
        h: "hour",
        d: "day"
      },
      typeToAction: {
        kick: "kick",
        tempmute: "mute",
        tempban: "ban",
        permaban: "ban"
      }
    };
  },
  computed: {
    canAddPunishment() {
      if (this.typeOpt.value !== "null" && ["kick", "permaban"].includes(this.typeOpt.value) && !isNaN(parseInt(this.strikesInt)) && parseInt(this.strikesInt) > 0 && !this.displayPunishments.find(punishment => punishment.amount === this.strikesInt)) return true;
      else if (this.typeOpt.value !== "null" && ["tempmute", "tempban"].includes(this.typeOpt.value) && !isNaN(parseInt(this.durationInt)) && parseInt(this.durationInt) > 0 && this.durationOpt.value !== "null" && !isNaN(parseInt(this.strikesInt)) && parseInt(this.strikesInt) > 0 && !this.displayPunishments.find(punishment => punishment.amount === this.strikesInt)) return true;
      return false;
    },
    canDiscardPunishment() {
      return this.typeOpt.value !== "null" || this.durationInt || this.durationOpt.value !== "null" || this.strikesInt;
    }
  },
  methods: {
    fetchGuildData: async function () {
      const response = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/cache`, {
        withCredentials: true,
        credentials: "same-origin"
      });
      this.cache = response.data.data;

      const settingsResponse = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/settings`, {
        withCredentials: true,
        credentials: "same-origin"
      });

      this.settings = settingsResponse.data.data;
      this.loaded = true;

      this.init();
    },
    init: function () {
      this.displayPunishments = this.cloneArray(this.settings.automated_punishments);
      this.displayPunishments = this.displayPunishments.sort((p1, p2) => parseInt(p1.amount) - parseInt(p2.amount));
    },
    remove: function (index) {
      this.displayPunishments.splice(index, 1);
      this.update("list");
    },
    cloneArray: function (array) {
      let newArray = [];
      for (const item of array) newArray.push(item);
      return newArray;
    },
    formUpdate: function () {
      if (this.durationOpt && !isNaN(parseInt(this.strikesInt)) && !isNaN(parseInt(this.durationInt)) && this.typeOpt) {
        this.saveAble = true;
      } else {
        this.saveAble = false;
      }
    },
    savePunishment: function () {
      if (!this.canAddPunishment) return;

      const actionObject = {
        duration: ["tempban", "tempmute"].includes(this.typeOpt.value) ? `${this.durationInt}${this.durationOpt.value}` : null,
        action: this.typeToAction[this.typeOpt.value],
        amount: this.strikesInt
      };
      this.displayPunishments.push(actionObject);
      this.displayPunishments = this.displayPunishments.sort((p1, p2) => parseInt(p1.amount) - parseInt(p2.amount));

      this.discardPunishment();
      this.update("list");

      this.saveAble = false;
    },
    identify: function (action) {
      return `${action.duration}/${action.amount}/${action.action}`;
    },
    arraify: function (object) {
      let output = [];
      for (const key of Object.keys(object)) {
        output.push(object[key]);
      }
      return output;
    },
    index: function (array) {
      const arr = [];
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        arr.push(Object.assign(item, { index: i }));
      }
      return arr;
    },
    fetchDuration: function (duration) {
      if (duration.startsWith("null")) return;
      const ibto = parseInt(duration.replace("m", "").replace("d","").replace("h", "").replace("s", "")) !== 1;
    
      if (ibto) {
        if (duration.endsWith("m")) {
          return duration.replace("m", " minutes");
        } else if (duration.endsWith("d")) {
          return duration.replace("d", " days");
        } else if (duration.endsWith("h")) {
          return duration.replace("h", " hours");
        } else if (duration.endsWith("s")) {
          return duration.replace("s", " seconds");
        } else {
          return "";
        }
      } else {
        if (duration.endsWith("m")) {
          return duration.replace("m", " minute");
        } else if (duration.endsWith("d")) {
          return duration.replace("d", " day");
        } else if (duration.endsWith("h")) {
          return duration.replace("h", " hour");
        } else if (duration.endsWith("s")) {
          return duration.replace("s", " second");
        } else {
          return "";
        }
      }
    },
    save: async function () {
      this.saving = true;

      await this.$axios.post(`${this.$apiBase}/v1/settings/${this.settings.id}/punishments`, {
        "punishments": JSON.stringify(this.displayPunishments)
      }, {
        withCredentials: true,
        credentials: "same-origin"
      });

      await this.fetchGuildData();
      this.changes = {};
      this.saving = false;
      this.updateBar();
    },
    update: async function (field) {
      switch(field) {
        case "list":
          console.log(this.settings.automated_punishments, this.displayPunishments);
          if (this.compareArray(this.settings.automated_punishments, this.displayPunishments)) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        default:
          console.error(`${field} is not a valid settings field.`);
      }
      this.updateBar();
    },
    updateBar: function () {
      console.log(this.arraify(this.changes));
      if (this.arraify(this.changes).some(c => c === true)) {
        this.confirm = true;
      } else {
        this.confirm = false;
      }
    },
    discard: function () {
      this.init();
      this.changes = {};
      this.updateBar();
    },
    compareArray: function (base, array) {
      var arrayToBase = false;
      var baseToArray = false;
      if (base.length !== array.length) return true;
      for (const item of array) {
        if (!base.includes(item)) {
          arrayToBase = true;
        }
      }
      for (const baseItem of base) {
        if (!array.includes(baseItem)) {
          baseToArray = true;
        }
      }
      if (arrayToBase || baseToArray) {
        return true;
      } else {
        return false;
      }
    },
    discardPunishment() {
      this.typeOpt = {
        label: "-",
        value: "null"
      };

      this.durationOpt = {
        label: "-",
        value: "null"
      };

      this.strikesInt = null;
      this.durationInt = null;
    },
    getPunishmentActionText() {
      if (this.typeOpt.value === "kick") return "kick the user from the server";
      else if (this.typeOpt.value === "tempmute") return `temporarily mute the user for ${parseInt(this.durationInt)} ${this.unitValueToTime[this.durationOpt.value]}${parseInt(this.durationInt) === 1 ? '' : 's'}`;
      else if (this.typeOpt.value === "tempban") return `temporarily ban the user from the server for ${parseInt(this.durationInt)} ${this.unitValueToTime[this.durationOpt.value]}${parseInt(this.durationInt) === 1 ? '' : 's'}`;
      else if (this.typeOpt.value === "permaban") return "permanently ban the user from the server";
    }
  },
  mounted() {
    this.fetchGuildData();
  }
}
</script>

<style scoped>
.margin-border {
  border-bottom: 1px solid rgba(0,0,0,.5);
}

.no-left {
  left: 0!important;
}

.form-field h2 {
  font-weight: 750;
}

.button-flex-container a {
  min-height: 40px;
  width: 49%;
  padding: .5em .4em;
  font-size: 0.9em;
}

.input-wrapper {
  min-height: 40px;
}

.punishment-showcase {
  width: 100%;
  text-align: center;
  background-color: var(--black-blue);
  padding: 0.5em;
  border-radius: 3px;
  border: 1px solid var(--grey);
  font-size: 0.95em;
  transition: .3s;
}
</style>